// Word limits and stage metadata shared across UI
export const INITIAL_STORY_LIMIT = 400;

export const TIER_LIMITS = {
  free: 150,
  basic: 250,
  premium: 350,
  professional: null,
};

export const TIERS = [
  {
    key: "free",
    name: "Free",
    price: "$0",
    subtitle: "Try a single dispute",
    bullets: [
      "Initial Story: 400 words",
      "Subsequent turns: 150 words",
      "Guided 8-stage flow",
      "AI neutral summary",
    ],
    cta: "Start free",
  },
  {
    key: "basic",
    name: "Basic",
    price: "$9/mo",
    subtitle: "For everyday conflicts",
    bullets: [
      "Initial Story: 400 words",
      "Subsequent turns: 250 words",
      "Up to 5 active cases",
      "Save drafts",
    ],
    cta: "Choose Basic",
  },
  {
    key: "premium",
    name: "Premium",
    price: "$19/mo",
    subtitle: "Detailed resolution",
    bullets: [
      "Initial Story: 400 words",
      "Subsequent turns: 350 words",
      "Unlimited cases",
      "Priority AI summaries",
    ],
    highlight: false,
    cta: "Choose Premium",
  },
  {
    key: "professional",
    name: "Professional",
    price: "Contact",
    subtitle: "Mediators & teams",
    bullets: [
      "Initial Story: 400 words",
      "Subsequent turns: Custom",
      "Mediator tools",
      "Vetting & compliance",
    ],
    highlight: true,
    cta: "Talk to us",
  },
];

export function computeStageLimit(tier, stageIndex, customLimit) {
  if (stageIndex === 0) return INITIAL_STORY_LIMIT;
  if (tier === "professional") return Number(customLimit) || 400;
  return TIER_LIMITS[tier] ?? 150;
}

export function countWords(text) {
  if (!text) return 0;
  return text.trim().split(/\s+/).filter(Boolean).length;
}

export const TIER_RANK = { free: 0, basic: 1, premium: 2, professional: 3 };

export function canUseTier(userTier, caseTier) {
  const u = TIER_RANK[(userTier || "free").toLowerCase()] ?? 0;
  const c = TIER_RANK[caseTier] ?? 0;
  return c <= u;
}

export function tierSubsequentLabel(tier, customLimit) {
  if (tier === "professional") return `${customLimit || "Custom"} words`;
  return `${TIER_LIMITS[tier]} words`;
}
